import { Route } from '@angular/router';
import { SbShareOfVoiceComponent } from '../../../../../pages/statistics/sb-share-of-voice/sb-share-of-voice.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const shareOfVoice: Route = {
  path: 'share-of-voice',
  component: SbShareOfVoiceComponent,
  title: 'nav.reporting.content.shareOfVoice',
  data: {
    breadcrumb: 'nav.reporting.content.shareOfVoice',
    icon: SbIcons.pieChartStake,
    id: RoutingID.shareOfVoice,
  },
};
